<template>
  <div>
    <header>
      <navbar/>
    </header>
    <main>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </main>
    <footer>
      <Footer/>
    </footer>
    <!-- <rewards></rewards> -->
  </div>
</template>

<script>
import Navbar from "@/components/navbar";
import Footer from "@/components/footer";
import Rewards from "../components/rewards";

export default {
  name: "index",
  components: {
    Rewards,
    Footer,
    Navbar,
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/index.vue